import http from '@/http'

const PATH = (id) => `/customers/${id}/cancellations`

export default {
    /**
     * @param {{customerId: number, params: {}}} data
     * @returns {Promise<void>}
     */
    async listCancellations ({customerId, params}) {
        try {
            const response = await http.get(PATH(customerId), {params})
            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    },
    /**
     * @param {{customerId: number, cancellationId: number}} data
     * @returns {Promise<void>}
     */
    async showCancellation ({customerId, cancellationId}) {
        try {
            const response = await http.get(`${PATH(customerId)}/${cancellationId}`)
            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    }
}
